import type { ViewFilter } from '../types';

export type ViewState = 'all' | 'assigned' | 'other';

export const deriveViewState = (viewFilter: ViewFilter | null, userId: string | undefined): ViewState => {
    if (viewFilter === null) {
        return 'all';
    }

    // User identity not loaded yet — avoid flashing the "viewing as other" UI
    if (userId === undefined) {
        return 'assigned';
    }

    return viewFilter.id === userId ? 'assigned' : 'other';
};
